/**
 * Account Register Modal Handler
 * Handles delayed popup display and cookie-based persistence
 */

class AccountRegisterModal {
  constructor() {
    this.modal = document.querySelector('#PopupModal-AccountRegister-1');
    this.cookieName = 'account_register_modal_dismissed';
    this.cookieExpireDays = 30; // Cookie expires after 30 days
    
    if (this.modal) {
      this.init();
    }
  }

  init() {
    // Check if user has already dismissed the modal
    if (this.getCookie(this.cookieName)) {
      return; // Don't show modal if cookie exists
    }

    // Get delay from data attribute (in milliseconds)
    const delay = parseInt(this.modal.getAttribute('data-popup-delay')) || 0;
    
    // Set up the delayed trigger
    if (delay > 0) {
      setTimeout(() => {
        this.showModal();
      }, delay);
    } else {
      this.showModal();
    }

    // Add event listeners for modal close actions
    this.setupCloseHandlers();
  }

  showModal() {
    if (this.modal && !this.getCookie(this.cookieName)) {
      this.modal.show();
    }
  }

  setupCloseHandlers() {
    // Handle close button click
    const closeButton = this.modal.querySelector('[id^="ModalClose-"]');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.handleModalDismiss();
      });
    }

    // Handle ESC key and background click (these are handled by the parent ModalDialog class)
    // We need to listen for the modalClosed event that's dispatched by the parent class
    document.body.addEventListener('modalClosed', () => {
      // Check if the closed modal was our account register modal
      if (this.modal && !this.modal.hasAttribute('open')) {
        this.handleModalDismiss();
      }
    });

    // Handle clicking outside the modal
    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) {
        this.handleModalDismiss();
      }
    });
  }

  handleModalDismiss() {
    // Set cookie to prevent modal from showing again
    this.setCookie(this.cookieName, 'true', this.cookieExpireDays);
  }

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }
}

// Initialize the modal when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new AccountRegisterModal();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AccountRegisterModal();
  });
} else {
  new AccountRegisterModal();
}